const STATUS_CANCELLED = 'cancelled';
const STATUS_PENDING = 'pending';
const APPROVAL_APPROVED = 'approved';
const LEG_REMOVED = 'removed';
export var FlightOrderFlag;
(function (FlightOrderFlag) {
    FlightOrderFlag["awaiting"] = "awaiting";
    FlightOrderFlag["confirmed"] = "confirmed";
    FlightOrderFlag["overdue"] = "overdue";
})(FlightOrderFlag || (FlightOrderFlag = {}));
export function flightOrderLegFlag(args) {
    var _a;
    const { order, approval, legId } = args;
    if (!order || order.status === STATUS_CANCELLED) {
        return undefined;
    }
    if ((approval === null || approval === void 0 ? void 0 : approval.legState) === LEG_REMOVED) {
        return undefined;
    }
    if (!order.sentAt || order.status === STATUS_PENDING) {
        return undefined;
    }
    return isConfirmed(order, approval, legId)
        ? FlightOrderFlag.confirmed
        : ((_a = order.reminderCount) !== null && _a !== void 0 ? _a : 0) > 0
            ? FlightOrderFlag.overdue
            : FlightOrderFlag.awaiting;
}
export const FLIGHT_ORDER_FLAG_LEVEL = {
    [FlightOrderFlag.awaiting]: 'warning',
    [FlightOrderFlag.confirmed]: 'valid',
    [FlightOrderFlag.overdue]: 'error',
};
export function worstFlightOrderFlag(left, right) {
    if (left === undefined || right === undefined) {
        return left !== null && left !== void 0 ? left : right;
    }
    return SEVERITY[left] >= SEVERITY[right] ? left : right;
}
const SEVERITY = {
    [FlightOrderFlag.confirmed]: 0,
    [FlightOrderFlag.awaiting]: 1,
    [FlightOrderFlag.overdue]: 2,
};
function isConfirmed(order, approval, legId) {
    var _a, _b, _c, _d, _e;
    if (approval) {
        return approval.status === APPROVAL_APPROVED;
    }
    if (legId && ((_b = (_a = order.pendingChanges) === null || _a === void 0 ? void 0 : _a.changes) !== null && _b !== void 0 ? _b : []).some((change) => change.legId === legId)) {
        return false;
    }
    return ((_c = order.legCount) !== null && _c !== void 0 ? _c : 0) > 0 && ((_d = order.approvedLegCount) !== null && _d !== void 0 ? _d : 0) >= ((_e = order.legCount) !== null && _e !== void 0 ? _e : 0);
}
//# sourceMappingURL=flightOrderFlag.js.map